import { render } from "./Router.vue?vue&type=template&id=09b49f62&scoped=true"
import script from "./Router.vue?vue&type=script&lang=js"
export * from "./Router.vue?vue&type=script&lang=js"

import "./Router.vue?vue&type=style&index=0&id=09b49f62&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b49f62"]])

export default __exports__